/**
 * @author: Brendan (Convx)
 * @description: Handles Zapiet Delivery Widget modifications on main-cart.liquid
 * @Brands: Kenny Hills Bakers 
 */

(function () {
    // Configurable settings for future use
    const settings = {
      debug: false, // Set to true to log debug messages
    };
  
    /**
     * Utility: Log debug messages if enabled
     */
    function logDebug(message) {
      if (settings.debug) {
        console.log("[Zapiet Widget]:", message);
      }
    }

    /**
     * Inject CSS to prevent FOUC (Flash of Unstyled Content)
     */
    function injectHideCSS() {
      const styleId = 'zapiet-hide-style';
      
      // Don't inject if already exists
      if (document.getElementById(styleId)) {
        return;
      }

      const css = `
        /* Hide the title item (has success class) */
        #storePickupApp .checkoutMethodContainer.pickup > .ZapietStack > .ZapietStack-Item--fullWidth,
        /* Hide the location dropdown item (has ZapietLocations-List class) */
        #storePickupApp .checkoutMethodContainer.pickup > .ZapietStack > .ZapietStack-Item:has(.ZapietLocations-List) {
          display: none !important;
        }
      `;
      console.log("css",css)

      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      
      // Insert as early as possible in the head to ensure it takes effect quickly
      const head = document.head || document.getElementsByTagName('head')[0];
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
      
      logDebug("Injected CSS to prevent FOUC");
    }
  
    /**
     * Check if we're on the main-cart.liquid
     * (for example, by checking a specific container or body class)
     */
    function isMainCart() {
      return document.querySelector(".cart") !== null;
    }
  
    /**
     * #2976 - Hide the first two ZapietStack-Item elements (Title & Location dropdown selection)
     * Returns true if successfully hidden, false otherwise
     */
    function hideFirstTwoZapietItems() {
      // Find and hide the title item
      const titleItem = document.querySelector(
        "#storePickupApp .checkoutMethodContainer.pickup .ZapietStack > .ZapietStack-Item--fullWidth"
      );
      
      // Find and hide the location dropdown item
      const locationItem = document.querySelector(
        "#storePickupApp .checkoutMethodContainer.pickup .ZapietStack > .ZapietStack-Item:has(.ZapietLocations-List)"
      );

      if (titleItem && locationItem) {
        titleItem.style.display = "none";
        locationItem.style.display = "none";
        logDebug("Successfully hid title and location items");
        return true;
      } else {
        logDebug("Could not find both title and location items");
        return false;
      }
    }

    /**
     * Retry mechanism for hiding Zapiet items
     */
    function retryHideZapietItems(maxAttempts = 10, interval = 200) {
      let attempts = 0;
    
      function tryHide() {
        if (hideFirstTwoZapietItems()) {
          logDebug("Successfully hid Zapiet items after " + (attempts + 1) + " attempts");
          return;
        }
        
        attempts++;
        if (attempts < maxAttempts) {
          logDebug("Retry attempt " + (attempts + 1) + " of " + maxAttempts);
          setTimeout(tryHide, interval);
        } else {
          logDebug("Failed to hide Zapiet items after maximum attempts");
        }
      }
    
      tryHide();
    }
  
    /**
     * Bind click handlers to Zapiet tabs
     */
    function bindZapietTabClicks() {
      const tabs = document.querySelectorAll(
        "#storePickupApp .checkoutMethodsContainer .checkoutMethod"
      );
  
      if (!tabs.length) {
        logDebug("No Zapiet checkoutMethod tabs found.");
        return;
      }
  
      tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          logDebug("Zapiet tab clicked, starting retry mechanism...");
          retryHideZapietItems();
        });
      });
  
      logDebug("Click handlers bound to Zapiet tabs.");
    }
  
    /**
     * Retry mechanism for initial binding
     */
    function waitForZapietTabsAndBind(maxAttempts = 10, interval = 300) {
      let attempts = 0;
    
      function tryBind() {
        const tabs = document.querySelectorAll(
          "#storePickupApp .checkoutMethodsContainer .checkoutMethod"
        );
    
        if (tabs.length) {
          logDebug("Zapiet tabs found. Binding click handlers.");
          bindZapietTabClicks();
          // Try to hide elements on initial load
          retryHideZapietItems();
        } else {
          attempts++;
          if (attempts < maxAttempts) {
            logDebug("Zapiet tabs not found yet, retrying...");
            setTimeout(tryBind, interval);
          } else {
            logDebug("Zapiet tabs not found after maximum attempts.");
          }
        }
      }
    
      tryBind();
    }
  
    /**
     * Initialize the widget modifications
     */
    function initZapietWidget() {
      if (!isMainCart()) {
        logDebug("Not on main-cart.liquid, skipping Zapiet widget init");
        return;
      }

      // Inject CSS as early as possible
      injectHideCSS();
      waitForZapietTabsAndBind();
    }
  
    // Run as early as possible
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initZapietWidget);
    } else {
      initZapietWidget();
    }
})();
  
